import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeGoogleCodeApi } from "../api/auth/authApi";
import { useAuthStore } from "../store/auth/auth.store";

const LoginCallback: React.FC = () => {
  const navigate = useNavigate();
  const { setLogin } = useAuthStore();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (!code) {
      navigate("/login", { replace: true });
      return;
    }

    exchangeGoogleCodeApi(code)
      .then(({ accessToken, refreshToken }) => {
        setLogin(accessToken, refreshToken);
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        console.error("[LoginCallback] token exchange failed:", err);
        navigate("/login", { replace: true });
      });
  }, [navigate, setLogin]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "var(--app-bg)",
        color: "var(--app-text-muted)",
        fontSize: 16,
      }}
    >
      로그인 처리 중...
    </div>
  );
};

export default LoginCallback;
